var exports = {
  "bW": "triggerButton__4WjF_K",
  "OW": "caret__BHAVXx",
  "s$": "overlayContent__bAsca4",
  "ns": "overlayTitle__QS4V5I",
  "nK": "overlayDescription__ZEkMcJ",
  "y": "copyField___KxzuW",
  "sH": "copyInput__GNBD7M",
  "cL": "copyButton__ujvExd",
  "SZ": "tabPanel__HGGz2c",
  "qr": "footer__Cn80qH",
};

module.exports = exports;
